(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("SettingsController", SettingsController);

    function SettingsController(
        toastr,
        StoreService,
        Principal,
        ModalFactory,
        $localStorage,
        Auth,
        JhiLanguageService,
        $translate,
        moment,
        $scope,
        $rootScope,
        $stateParams,
        $timeout,
        SettingsService,
        FlyersService,
        uploadFileConstants
    ) {
        var format = "DD/MM/YYYY";
        var vm = this;

        vm.maskLocale = "99/99/9999";

        vm.fbPixelPrefixAddon = " - Pixel";
        vm.glAnalyticsPrefixAddon = " - ID";
        vm.redirectURLPrefixAddon = "https://www.";

        vm.stores = [];
        vm.hasShipping = false;

        vm.store = $localStorage.defaultStore;

        vm.error = null;
        vm.settingsAccount = null;
        vm.success = null;

        // Loading controls
        vm.isUploadingProfileImage = false;
        vm.isUploadingBanner = false;
        vm.isUploadingBannerMobile = false;

        var UPLOAD_PROFILE_PICTURE_CONTEXT = 'profilePicture';
        var UPLOAD_PROFILE_BANNER_CONTEXT = 'profileBanner';
        var UPLOAD_PROFILE_BANNER_MOBILE_CONTEXT = 'profileBannerMobile';
        var MAX_IMAGE_SIZE = 10240; // 10MB in KB

        vm.islocked = $localStorage.isMoipPlanFree;
        $timeout(function () {
            if ($stateParams.tab) {
                vm.tab = $stateParams.tab;
            }
        }, 500);

        StoreService.getMyAllStores().then(function (response) {
            if (response && response.data) {
                response.data.forEach(function (elem) {
                    var store = {};
                    store.nickname = elem.nickname;
                    store.id = elem.id;
                    store.redirectURL = elem.redirectURL;
                    store.fbPixel = elem.fbPixel;
                    store.glAnalytics = elem.glAnalytics;
                    store.fbActivation = elem.fbActivation;

                    vm.stores.push(store);
                });
            }
        });

        isUserSubscribed();

        vm.authShipping = function () {
            StoreService.authorizeShipping().then(function (response) {});
        };

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                gender: account.gender,
                twoFactorAuth: account.twoFactorAuth,
                dateOfBirth: moment(account.dateOfBirth).format(format),
                phone: account.phone,
                moipAccountInfo: account.moipAccountInfo,
                accountDTO: account.accountDTO,
            };
        };

        function checkExistPicturesAccount() {
            if (vm.settingsAccount.accountDTO) {
                if (
                    vm.settingsAccount.accountDTO.imageProfile &&
                    vm.settingsAccount.accountDTO.imageProfile.path
                ) {
                    vm.profileImagePreview =
                        vm.settingsAccount.accountDTO.imageProfile.path;
                }
                if (
                    vm.settingsAccount.accountDTO.banner &&
                    vm.settingsAccount.accountDTO.banner.path
                ) {
                    vm.bannerImagePreview =
                        vm.settingsAccount.accountDTO.banner.path;
                }
                if (
                    vm.settingsAccount.accountDTO.bannerMobile &&
                    vm.settingsAccount.accountDTO.bannerMobile.path
                ) {
                    vm.bannerMobileImagePreview =
                        vm.settingsAccount.accountDTO.bannerMobile.path;
                }
            }
        }

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);

            if (vm.settingsAccount.moipAccountInfo) {
                vm.addressDTO = vm.settingsAccount.moipAccountInfo;
            }
            checkExistPicturesAccount();
            dateTimePicker();
        });

        vm.openModal = function () {
            $localStorage.isLocked = true;
        };

        vm.selectProfileImage = function () {
            document.getElementById("fileInputProfile").click();
        };
        vm.selectBannerImage = function () {
            document.getElementById("fileInputBanner").click();
        };
        vm.selectBannerMobileImage = function () {
                document.getElementById("fileInputBannerMobile").click();
        };

        function getRemoveFunction(type) {
             if (type === UPLOAD_PROFILE_PICTURE_CONTEXT) {
                 return vm.removeProfileImage;
             } else if (type === UPLOAD_PROFILE_BANNER_CONTEXT) {
                 return vm.removeBannerImage;
             } else if (type === UPLOAD_PROFILE_BANNER_MOBILE_CONTEXT) {
                 return vm.removeBannerMobileImage;
             }
         };

        function verifyRemoveImage($event, type) {
            $event.stopPropagation();
             ModalFactory.openWarningModal(
                 null,
                 $translate.instant("settings.modals.remove-modal.subtitle-image"),
                 $translate.instant("settings.modals.remove-modal.small-text"),
                 null,
                 $translate.instant("settings.modals.confirm"),
                 $translate.instant("settings.modals.cancel"),
                 getRemoveFunction(type)
             );
        }

        vm.removeProfileImage = function () {
            if (
                vm.settingsAccount.accountDTO &&
                vm.settingsAccount.accountDTO.imageProfile
            ) {
                vm.settingsAccount.accountDTO.imageProfile = null;
            }
            vm.profileImagePreview = null;
        };

        vm.removeBannerImage = function () {
            if (
                vm.settingsAccount.accountDTO &&
                vm.settingsAccount.accountDTO.banner
            ) {
                vm.settingsAccount.accountDTO.banner = null;
            }
            vm.bannerImagePreview = null;
        };

        vm.removeBannerMobileImage = function () {
            if (vm.settingsAccount.accountDTO && vm.settingsAccount.accountDTO.bannerMobile) {
                vm.settingsAccount.accountDTO.bannerMobile = null;
            }
            vm.bannerMobileImagePreview = null;
        };

        vm.verifyRemoveProfileImage = function ($event) {
            verifyRemoveImage($event, UPLOAD_PROFILE_PICTURE_CONTEXT);
        };

        vm.verifyRemoveBannerImage = function ($event) {
            verifyRemoveImage($event, UPLOAD_PROFILE_BANNER_CONTEXT);
        };

        vm.verifyRemoveBannerMobileImage = function ($event) {
            verifyRemoveImage($event, UPLOAD_PROFILE_BANNER_MOBILE_CONTEXT);
        };

        vm.removeBannerMobileImage = function () {
            if (
                vm.settingsAccount.accountDTO &&
                vm.settingsAccount.accountDTO.bannerMobile
            ) {
                vm.settingsAccount.accountDTO.bannerMobile = null;
            }
            vm.bannerMobileImagePreview = null;
        };

        vm.handleProfileImage = function ($event) {
            var file = $event.target.files[0];
            if (file) {
                if (file.size / 1024 > MAX_IMAGE_SIZE) {
                    toastr.error(
                        $translate.instant(
                            "settings.store.messages.error.image.limit-size"
                        )
                    );
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        vm.profileImagePreview = e.target.result;
                    });
                };
                reader.readAsDataURL(file);

                vm.isUploadingProfileImage = true;
                FlyersService.uploadFileProfile(file, UPLOAD_PROFILE_PICTURE_CONTEXT, uploadFileConstants.ASSET_FILE_DESTINATION.PROFILE)
                    .then(function (response) {
                        if (response.data === null) {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.limit-size"
                                )
                            );
                        } else {
                            if (!vm.settingsAccount.accountDTO) vm.settingsAccount.accountDTO = {};
                            vm.settingsAccount.accountDTO.imageProfile = response.data;
                        }
                    })
                    .catch(function (error) {
                        if (error.data && error.data.description) {
                            if (error.data.description === "Unsupported image format") {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.file-format"
                                    )
                                );
                            } else if (error.data.description.startsWith("The image file size exceeded the size limit of")) {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.limit-size"
                                    )
                                );
                            } else {
                                toastr.error(
                                    error.data.description ||
                                    $translate.instant(
                                        "settings.store.messages.error.image.default"
                                    )
                                );
                            }
                        } else {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.default"
                                )
                            );
                        }
                    })
                    .finally(function() {
                        vm.isUploadingProfileImage = false;
                    });
            }
        };

        vm.handleBannerImage = function ($event) {
            var file = $event.target.files[0];
            if (file) {
                if (file.size / 1024 > MAX_IMAGE_SIZE) {
                    toastr.error(
                        $translate.instant(
                            "settings.store.messages.error.image.limit-size"
                        )
                    );
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        vm.bannerImagePreview = e.target.result;
                    });
                };
                reader.readAsDataURL(file);

                vm.isUploadingBanner = true;
                FlyersService.uploadFileProfile(file, UPLOAD_PROFILE_BANNER_CONTEXT, uploadFileConstants.ASSET_FILE_DESTINATION.PROFILE_BANNER)
                    .then(function (response) {
                        if (response.data === null) {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.limit-size"
                                )
                            );
                        } else {
                            if (!vm.settingsAccount.accountDTO) vm.settingsAccount.accountDTO = {};
                            vm.settingsAccount.accountDTO.banner = response.data;
                        }
                    })
                    .catch(function (error) {
                        if (error.data && error.data.description) {
                            if (error.data.description === "Unsupported image format") {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.file-format"
                                    )
                                );
                            } else if (error.data.description.startsWith("The image file size exceeded the size limit of")) {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.limit-size"
                                    )
                                );
                            } else {
                                toastr.error(
                                    error.data.description ||
                                    $translate.instant(
                                        "settings.store.messages.error.image.default"
                                    )
                                );
                            }
                        } else {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.default"
                                )
                            );
                        }
                    })
                    .finally(function() {
                        vm.isUploadingBanner = false;
                    });
            }
        };

        vm.handleBannerMobileImage = function ($event) {
            var file = $event.target.files[0];
            if (file) {
                if (file.size / 1024 > MAX_IMAGE_SIZE) {
                    toastr.error(
                        $translate.instant(
                            "settings.store.messages.error.image.limit-size"
                        )
                    );
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        vm.bannerMobileImagePreview = e.target.result;
                    });
                };
                reader.readAsDataURL(file);

                vm.isUploadingBannerMobile = true;
                FlyersService.uploadFileProfile(file, UPLOAD_PROFILE_BANNER_MOBILE_CONTEXT, uploadFileConstants.ASSET_FILE_DESTINATION.PROFILE_BANNER_MOBILE)
                    .then(function (response) {
                        if (response.data === null) {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.limit-size"
                                )
                            );
                        } else {
                            if (!vm.settingsAccount.accountDTO) vm.settingsAccount.accountDTO = {};
                            vm.settingsAccount.accountDTO.bannerMobile = response.data;
                        }
                    })
                    .catch(function (error) {
                        if (error.data && error.data.description) {
                            if (error.data.description === "Unsupported image format") {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.file-format"
                                    )
                                );
                            } else if (error.data.description.startsWith("The image file size exceeded the size limit of")) {
                                toastr.error(
                                    $translate.instant(
                                        "settings.store.messages.error.image.limit-size"
                                    )
                                );
                            } else {
                                toastr.error(
                                    error.data.description ||
                                    $translate.instant(
                                        "settings.store.messages.error.image.default"
                                    )
                                );
                            }
                        } else {
                            toastr.error(
                                $translate.instant(
                                    "settings.store.messages.error.image.default"
                                )
                            );
                        }
                    })
                    .finally(function() {
                        vm.isUploadingBannerMobile = false;
                    });
            }
        };

        vm.savePersonalData = function(form, test) {
            if (form.$valid) {
                vm.isSaving = true;
                var accountToSave = angular.copy(vm.settingsAccount);
                accountToSave.dateOfBirth = moment(
                    vm.settingsAccount.dateOfBirth,
                    format
                ).toDate();

                if (accountToSave.dateOfBirth.toString() === "Invalid Date"){
                    toastr.error(
                        $translate.instant("settings.store.messages.error.invaliddateofbirth")
                    );
                    vm.isSaving = false;
                    return;
                }

                Auth.updateAccount(accountToSave)
                    .then(function () {
                        vm.error = null;
                        vm.success = 'OK';
                        Principal.identity(true).then(function(account) {
                            vm.settingsAccount = copyAccount(account);
                            var imagePath = null;
                            if (account.accountDTO && account.accountDTO.imageProfile && account.accountDTO.imageProfile.path) {
                                imagePath = account.accountDTO.imageProfile.path;
                            }
                            $rootScope.$emit('profileImageChanged', imagePath);
                            JhiLanguageService.getCurrent().then(function(current) {
                                if (vm.settingsAccount && vm.settingsAccount.langKey !== current) {
                                    $translate.use(vm.settingsAccount.langKey)
                                        .then(function(result) {
                                            processResponse();
                                            vm.isSaving = false;
                                        }, function(err) {
                                            processResponse();
                                            vm.isSaving = false;
                                        });
                                } else {
                                    vm.isSaving = false;
                                    vm.error = null;
                                    processResponse();
                                }
                            }, function(err) {
                                vm.isSaving = false;
                            });
                        }, function(err) {
                            vm.isSaving = false;
                        });
                    }).catch(function(error) {
                    if (error.status === 401) {
                        toastr.success($translate.instant('settings.store.messages.success.login'));
                    }
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        };

        vm.saveURLRedirectDomainsData = function () {
            if (vm.stores.length > 0) {
                vm.isSaving = true;
                vm.stores.forEach(function (elem) {
                    elem.redirectURL = splitAbsoluteUrl(
                        "http://www.",
                        elem.redirectURL
                    );
                    elem.redirectURL = splitAbsoluteUrl(
                        "http://",
                        elem.redirectURL
                    );
                    elem.redirectURL = splitAbsoluteUrl(
                        "https://",
                        elem.redirectURL
                    );
                    elem.redirectURL = splitAbsoluteUrl(
                        "https://www.",
                        elem.redirectURL
                    );
                    elem.redirectURL = splitAbsoluteUrl(
                        "www.",
                        elem.redirectURL
                    );
                });

                StoreService.saveRedirectDomains(vm.stores).then(
                    function (response) {
                        vm.isSaving = false;
                        vm.error = null;
                        vm.success = "OK";
                        processResponse();
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = "ERROR";
                    }
                );
            }
        };

        vm.saveAnalyticsData = function () {
            vm.isSaving = true;
            StoreService.saveStoreAnalytics(vm.stores).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = "OK";
                    processResponse();
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = "ERROR";
                }
            );
        };

        function splitAbsoluteUrl(url, value) {
            if (value) {
                if (value.includes(url)) {
                    return value.split(url)[1];
                }
            }
            return value;
        }

        function dateTimePicker() {
            vm.dateOfBirthOptions = {
                format: format,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                maxDate: moment(),
                widgetPositioning: {
                    horizontal: "right",
                    vertical: "bottom",
                },
            };

            angular
                .element("#dateOfBirth")
                .datetimepicker(vm.dateOfBirthOptions)
                .on("dp.change", function (ev) {
                    if (ev.date) {
                        $scope.$apply(function () {
                            vm.settingsAccount.dateOfBirth =
                                ev.date.format(format);
                        });
                    } else {
                        $scope.$apply(function () {
                            vm.settingsAccount.dateOfBirth = undefined;
                        });
                    }
                });
        }

        function processResponse() {
            if (vm.error) {
                toastr.error(
                    $translate.instant("settings.store.messages.error.fail")
                );
                vm.error = undefined;
            } else if (vm.success && vm.success === "OK") {
                vm.success = undefined;
                vm.isSaving = false;
                toastr.success(
                    $translate.instant("settings.store.messages.success")
                );
            }
        }

        function actualyDisconnect() {
            Principal.disconnectFromPaymentGateway().then(function (response) {
                if (response.data == "OK") {
                    vm.moipInfo = {};
                }
            });
        }

        vm.changeWebNotifications = function () {
            if (vm.webNotifications) {
                subscribeButtonHandler();
            } else {
                if (vm.registerId != null) {
                    SettingsService.unregisterToReceiveNotifications(
                        vm.registerId
                    ).then(function (data) {
                        navigator.serviceWorker
                            .getRegistration()
                            .then(function (data) {
                                data.pushManager
                                    .getSubscription()
                                    .then(function (data) {
                                        data.unsubscribe();
                                        vm.webNotifications = false;
                                    });
                            });
                    });
                }
            }
        };

        vm.changeSystemNotifications = function () {
            SettingsService.updateSystemNotifications(
                vm.registerId,
                vm.systemNotifications
            ).then(function (data) {
                $rootScope.$emit("settings-updated");
            });
        };

        vm.changeEmailNotifications = function () {
            SettingsService.updateEmailNotifications(
                vm.registerId,
                vm.systemNotifications
            ).then(function (data) {
                $rootScope.$emit("settings-updated");
            });
        };

        function urlB64ToUint8Array(base64String) {
            const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, "+")
                .replace(/_/g, "/");
            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
            for (var i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }

        function subscribeButtonHandler() {
            // Prevent the user from clicking the subscribe button multiple times.
            Notification.requestPermission().then(function (result) {
                if (result === "denied") {
                    toastr.error(
                        $translate.instant("settings.notifications.error")
                    );
                    vm.webNotifications = false;
                    return;
                }

                navigator.serviceWorker
                    .getRegistration()
                    .then(function (registration) {
                        if (registration) {
                            registration.pushManager
                                .getSubscription()
                                .then(function (subscribed) {
                                    if (subscribed) {
                                        return;
                                    }
                                    registration.pushManager
                                        .subscribe({
                                            userVisibleOnly: true,
                                            applicationServerKey:
                                                urlB64ToUint8Array(
                                                    "BI4I7aPcZIoAL7ZpvzE3vxlpAfBdswMmokjuAoE47H8DLOus99-Rsw5nJQLr93YWXo4Xr5f-jIQZ6ONSSD0eClY"
                                                ),
                                        })
                                        .then(function (subscription) {
                                            const subscriptionJSON = JSON.parse(
                                                JSON.stringify(subscription)
                                            );
                                            SettingsService.registerToReceiveNotifications(
                                                subscriptionJSON.endpoint,
                                                subscriptionJSON.keys.auth,
                                                subscriptionJSON.keys.p256dh,
                                                $localStorage.userId,
                                                vm.store.storeId
                                            ).then(function (data) {
                                                vm.registerId = data.id;
                                                vm.webNotifications = true;
                                            });
                                        });
                                });
                        } else {
                            toastr.error(
                                $translate.instant(
                                    "settings.notifications.error"
                                )
                            );
                            vm.webNotifications = false;
                        }
                    });
            });
        }

        function isUserSubscribed() {
            vm.webNotifications = false;
            vm.systemNotifications = false;
            vm.emailNotifications = false;

            SettingsService.getRegister(
                $localStorage.userId,
                vm.store.storeId
            ).then(function (data) {
                vm.systemNotifications = data["soundNotification"];
                vm.emailNotifications = data["emailNotification"];
                vm.webNotifications = data["endpoint"] != null;
                vm.registerId = data["id"];
            });
        }
    }
})();
